import { LegalPage } from "@/components/LegalPage";

export default function CookiePolicy() {
  const openSettings = () => {
    if (window.cookiehub) {
      window.cookiehub.openSettings();
    }
  };

  return (
    <LegalPage title="Cookie Policy" updated="26 agosto 2026">
      <section>
        <h2>1. Cosa sono i cookie</h2>
        <p>
          I cookie sono piccoli file di testo che i siti web salvano sul tuo dispositivo per garantire il corretto
          funzionamento delle pagine e, quando consentito, per migliorare l'esperienza di navigazione.
        </p>
      </section>
      <section>
        <h2>2. Cookie utilizzati da questo sito</h2>
        <p>Questo sito utilizza esclusivamente <strong>cookie tecnici necessari</strong>, che non richiedono consenso:</p>
        <ul>
          <li>
            <strong>Cookie di sessione dell'area riservata</strong> — mantengono l'accesso degli amministratori alla
            gestione del catalogo.
          </li>
          <li>
            <strong>Cookie delle preferenze di consenso</strong> — memorizzano la tua scelta sul banner dei cookie,
            gestito dal servizio CookieHub.
          </li>
        </ul>
        <p>
          <strong>Non utilizziamo</strong> cookie di profilazione, cookie pubblicitari né strumenti di analisi di terze
          parti (Google Analytics, pixel social o simili).
        </p>
      </section>
      <section>
        <h2>3. Gestione del consenso</h2>
        <p>
          Il banner dei cookie è fornito da <strong>CookieHub</strong> (
          <a href="https://www.cookiehub.com" target="_blank" rel="noreferrer">
            www.cookiehub.com
          </a>
          ). Puoi modificare o revocare in qualsiasi momento le tue preferenze cliccando il pulsante qui sotto:
        </p>
        <p>
          <button
            onClick={openSettings}
            data-testid="cookie-settings-button"
            className="mt-2 border border-gold px-8 py-4 font-mono text-xs uppercase tracking-[0.3em] text-gold transition-colors duration-500 hover:bg-gold hover:text-void"
          >
            Impostazioni cookie
          </button>
        </p>
        <p>
          Puoi inoltre gestire o eliminare i cookie direttamente dalle impostazioni del tuo browser (Chrome, Safari,
          Firefox, Edge).
        </p>
      </section>
      <section>
        <h2>4. Aggiornamenti</h2>
        <p>
          Questa Cookie Policy può essere aggiornata periodicamente. La data dell'ultima revisione è indicata in cima
          alla pagina. Per qualsiasi domanda scrivi a{" "}
          <a href="mailto:carminelucariello@yahoo.it">carminelucariello@yahoo.it</a>.
        </p>
      </section>
    </LegalPage>
  );
}
